import React, { useRef, useEffect } from "react";

const Globe = ({ size = 250 }) => {
  const divRef = useRef(null);
  const s = size / 250;

  // rAF-driven animation — immune to Tailwind preflight's
  // `animation-duration: 0.01ms !important` (prefers-reduced-motion override)
  useEffect(() => {
    let pos = 0;
    const speed = (400 * s) / (30 * 60); // px/frame → 30s full cycle at 60fps
    let raf;

    const tick = () => {
      pos += speed;
      if (pos > 400 * s) pos = 0;
      if (divRef.current) {
        divRef.current.style.backgroundPosition = `${pos}px 0`;
      }
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [s]);

  return (
    <div
      ref={divRef}
      style={{
        position: "relative",
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        overflow: "hidden",
        flexShrink: 0,
        backgroundImage: "url('https://pub-940ccf6255b54fa799a9b01050e6c227.r2.dev/globe.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "0 0",
        boxShadow: [
          `0 0 ${Math.round(20*s)}px rgba(255,255,255,.2)`,
          `${Math.round(-5*s)}px 0 ${Math.round(8*s)}px #c3f4ff inset`,
          `${Math.round(15*s)}px ${Math.round(2*s)}px ${Math.round(25*s)}px #000 inset`,
          `${Math.round(-24*s)}px ${Math.round(-2*s)}px ${Math.round(34*s)}px #c3f4ff99 inset`,
          `${Math.round(250*s)}px 0 ${Math.round(44*s)}px #00000066 inset`,
          `${Math.round(150*s)}px 0 ${Math.round(38*s)}px #000000aa inset`,
        ].join(", "),
      }}
    />
  );
};

export default Globe;
